import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NewFreeStock } from '../../model';
import { Occ } from '../../occ';
import { ArticleRefs, ConsignmentArticleStock } from '../../occ/occ-models/occ-generated.models';

@Injectable({
  providedIn: 'root',
})
export class AssortmentConnector {
  constructor(private httpClient: HttpClient, private occEndpointsService: OccEndpointsService) {}

  requestNewFreeArticles(userId: string, requestedNewFreeArticles: NewFreeStock[]): Observable<Blob> {
    return this.httpClient.post(
      this.occEndpointsService.buildUrl('customerFreeStock', {
        urlParams: {
          userId,
        },
      }),
      requestedNewFreeArticles,
      {
        responseType: 'blob',
      }
    );
  }

  getConsignmentStockArticles(userId: string): Observable<string[]> {
    return this.httpClient
      .get<ArticleRefs>(
        this.occEndpointsService.buildUrl('consignmentStockArticles', {
          urlParams: {
            userId,
          },
        })
      )
      .pipe(map((res) => res.articleRefs));
  }

  getConsignmentStockArticleStockInformation(userId: string, articleNumber: string): Observable<ConsignmentArticleStock> {
    return this.httpClient.get<Occ.ConsignmentArticleStock>(
      this.occEndpointsService.buildUrl('consignmentStockArticleStockInformation', {
        urlParams: {
          userId,
          articleNumber,
        },
      })
    );
  }
}
